<template>
  <b-modal id="bv-modal-edit-monitor" size="lg" hide-footer centered>
    <template v-slot:modal-title>
      Edit Monitor {{ monitor.name }}
    </template>
    <b-form @submit.prevent="editMonitor">

      <b-form-group
        id="monitor-name-group"
        label="Topic Customer Insight Monitor"
        label-for="monitor-name"
      >
        <b-form-input
          id="monitor-name"
          v-model="editForm.name"
          type="text"
          required
          placeholder="Enter a name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="monitor-image-group"
        label="Image"
        label-for="monitor-image"
      >
        <b-form-file
          id="monitor-image"
          v-model="editForm.image"
          placeholder="Choose an image or drop it here..."
          ref="monitorImage"
          @change="onFileChange"
        ></b-form-file>
      </b-form-group>

      <b-row v-if="uploadedImageUrl" class="mb-3">
        <b-col cols="12" sm="6">
          <img :src="uploadedImageUrl" class="img-fluid" />
        </b-col>
      </b-row>

      <b-row class="justify-content-end mb-4">
        <b-col cols="auto">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-language-group"
              label="Language"
              label-for="monitor-language"
              v-if="monitorLanguages.length"
            >
              <b-form-radio-group
                id="monitor-language"
                v-model="editForm.language"
                :options="monitorLanguages"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="auto">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-group"
              :label="tagsLabel"
              label-for="monitor-tags"
              v-if="tagsCheckboxes.length"
            >
              <b-form-checkbox-group
                id="monitor-tags"
                v-model="editForm.tags"
                :options="tagsCheckboxes"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <div class="text-right">
        <b-button type="submit" variant="primary">Edit</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import {
  MONITOR_EDIT,
  MONITOR_GET_LIST_CONSUMER,
  MONITOR_GET_LIST_MARKET
} from "@/store/actions.type";

export default {
  name: 'MonitorEdit',
  props: ['category', 'monitor'],
  data() {
    return {
      tagsCheckboxes: [],
      editForm: {
        name: '',
        image: null,
        language: '',
        tags: []
      },
      monitorLanguages: [
        {
          text: 'Italian',
          value: '1'
        },
        {
          text: 'English',
          value: '2'
        }
      ],
      uploadedImageUrl: null
    }
  },
  computed: {
    ...mapGetters(["monitorConsumerGenerations", "monitorMarketSectors"]),
    tagsLabel: function() {
      let tagsLabel = '';
      if(this.category == 'consumer') {
        tagsLabel = 'Consumer';
      }
      if(this.category == 'market') {
        tagsLabel = 'Market';
      }
      return tagsLabel
    }
  },
  methods: {
    generateTagsOptions() {       
      this.tagsCheckboxes = [];
      let rawTags = [];
      if(this.category == 'consumer') {
        rawTags = this.monitorConsumerGenerations;
        for (var i = 0; i < rawTags.length; i++) {
          let singleTag = {
            text: rawTags[i].generation,
            value: rawTags[i].id
          }
          this.tagsCheckboxes.push(singleTag);
        }
      }
      if(this.category == 'market') {
        rawTags = this.monitorMarketSectors;
        for (var j = 0; j < rawTags.length; j++) {
          let singleTag = {
            text: rawTags[j].sector,
            value: rawTags[j].id
          }
          this.tagsCheckboxes.push(singleTag);
        }  
      }  
    },
    editMonitor() {
      let monitorData = new FormData();
      monitorData.set('name', this.editForm.name);
      monitorData.set('language', this.editForm.language);
      if(this.editForm.image) {
        monitorData.set('picture', this.editForm.image);
      }
      for (var i = 0; i < this.editForm.tags.length; i++) {
        if(this.category == 'consumer') {
          monitorData.append('generations', this.editForm.tags[i]);
        }
        if(this.category == 'market') {
          monitorData.append('sectors', this.editForm.tags[i]);
        }
      }
      let editedMonitor = {
        category: this.category,
        monitorId: this.monitor.id,
        monitor: monitorData
      }
      this.$store.dispatch(MONITOR_EDIT, editedMonitor).then(() => {
        this.$bvModal.hide('bv-modal-edit-monitor');
        this.$bvToast.toast(`Monitor ${this.monitor.name} has been edited successfully`, {
          title: 'Monitor edited',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        if(this.category == 'consumer') {
          this.$store.dispatch(MONITOR_GET_LIST_CONSUMER);
        }
        if(this.category == 'market') {
          this.$store.dispatch(MONITOR_GET_LIST_MARKET);
        }
      });
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.uploadedImageUrl = URL.createObjectURL(file);
    }
  },
  mounted() {
    this.generateTagsOptions();
  },
  watch: {
    category: function() {
      this.generateTagsOptions();
    },
    monitor: function() {
      this.editForm.id = this.monitor.id;
      this.editForm.name = this.monitor.name;
      if(this.monitor.picture) {
        this.uploadedImageUrl = this.monitor.picture;
      }
      this.editForm.language = this.monitor.language;

      let i;

      if(this.monitor.generations) {
        for (i = this.monitor.generations.length - 1; i >= 0; i--) {
          if(this.editForm.tags.includes(this.monitor.generations[i]) === false) {
            this.editForm.tags.push(this.monitor.generations[i]);
          }
        }
      }
      if(this.monitor.sectors) {
        for (i = this.monitor.sectors.length - 1; i >= 0; i--) {
          if(this.editForm.tags.indexOf(this.monitor.sectors[i]) === -1)
            this.editForm.tags.push(this.monitor.sectors[i]);
        }
      }
    }
  }
}
</script>